module.exports = __webpack_public_path__ + "static/media/biking-mountain.4e73d86f.svg";